//export {}; // keerp complier happy while code is disabled

 // AppInsightsInitializer.tsx
 import React, { useEffect } from 'react';
 import { useSelector } from 'react-redux';
 import { IApplicationState } from '../store';
 import { initializeAppInsights } from './appInsights'; // Adjust the import path as needed

 const AppInsightsInitializer: React.FC = () => {
     const appInsightsKey = useSelector((state: IApplicationState) => state.appSettings.appInsightsKey);

     useEffect(() => {
         console.log("App insight initialiser trigger");

         if (appInsightsKey) {
             initializeAppInsights(appInsightsKey);
         }
     }, [appInsightsKey]);

     return null; // This component does not render anything
 };

 export default AppInsightsInitializer;
